import qs from 'qs'
import axios from 'axios'
import Vue from 'vue'
export default function fetch({
  method = 'get',
  url,
  data,
  params,
  isJSON = true,
  useLoading = false
}) {
  let loading
  const prototype = Vue.prototype
  if (useLoading) {
    loading = prototype.$loading({
      lock: true,
      body: true
    })
  }
  const token = this.state.token
  let option = {
    method,
    url,
    data: isJSON ? data : typeof data === 'string' ? data : qs.stringify(data),
    params,
    headers: token ? { token } : {}
  }
  return axios(option)
    .then(function ({ data }) {
      if (loading) {
        loading.close()
      }
      if (
        data.success ||
        data.code === '40000' ||
        data.code === 0 ||
        data.code === 30208
      ) {
        if (data.code === 30208) {
          return data
        } else {
          if (data.data) {
            return data.data
          } else {
            return data
          }
        }
      } else {
        // eslint-disable-next-line no-throw-literal
        throw {
          // code: data.code,
          message: data.message
        }
      }
    })
    .catch((e) => {
      if (loading) {
        loading.close()
      }
      if (!e.response) {
        throw e
      } else {
        const data = e.response.data || {}
        const responseCode = data.code
        if (responseCode) {
          throw data
        }
      }
    })
}
